import getTranslate from './getTranslate';
import setTranslate from './setTranslate';
import minTranslate from './minTranslate';
import maxTranslate from './maxTranslate';
import translateTo from './translateTo';
export default {
  getTranslate: getTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/translate/index.js
// module id = 751
// module chunks = 169